// app/javascript/lib/text_fit.js
// Подстановка персонализации и автоподгонка длинного текста под предел ширины.
//
// Зеркало app/services/text_fit.rb. Общая таблица кейсов —
// test/fixtures/files/text_fit_cases.json, её читают оба тест-рана
// (test/javascript/text_fit.test.js и test/services/text_fit_test.rb),
// так что разъехаться формулам не дадут.
//
// КОНТРАКТ
//   w0        — ширина текста при БАЗОВОМ кегле, units (мм×100)
//   maxW      = cfg.max_width_mm * 100          (0/null/отрицательное → без предела)
//   minK      = clamp(max(MIN_SCALE, MIN_FONT_MM / fontSizeMm), 0, 1)
//   k_fit     = (maxW <= 0 || w0 <= maxW) ? 1 : max(maxW / w0, minK)
//   overflow  = maxW > 0 && w0 * minK > maxW
//   k         = k_fit * (override.font_scale || 1)
//
// ПОЧЕМУ scale(k), А НЕ ПОВТОРНАЯ ВЕКТОРИЗАЦИЯ
//   path(k·fs, k·ls) ≡ k·path(fs, ls) — точное тождество, если интервал масштабируется
//   вместе с кеглем. Браузер и сервер физически не могут разойтись.
//
// СЛЕДСТВИЯ
//   * k масштабирует ВСЮ надпись: путь, align-dx, baseline, обводку, смещение тени.
//   * dx_mm/dy_mm НЕ масштабируются на k и применяются ДО поворота.

export const MIN_SCALE = 0.6      // ниже 60% кегля не ужимаем
export const MIN_FONT_MM = 6.0    // и не ниже 6 мм по абсолюту

// Значение текст-слоя для рендера: персональное (имя/номер), иначе sample/content.
export function resolveText(cfg, recipient) {
  const pers = cfg?.personalization
  if (!pers?.enabled) return cfg?.content ?? ""
  if (!recipient) return pers.sample ?? ""
  return String((pers.field === "number" ? recipient.number : recipient.name) ?? "")
}

// Нижняя граница масштаба для этого кегля. 1 означает «ужимать некуда».
export function minScale(fontSizeMm) {
  const fs = Number(fontSizeMm) || 0
  const byFont = fs > 0 ? MIN_FONT_MM / fs : 1
  return Math.min(1, Math.max(0, Math.max(MIN_SCALE, byFont)))
}

export function fitScale(widthUnits, maxWidthUnits, fontSizeMm) {
  const w0 = Number(widthUnits) || 0
  const maxW = Number(maxWidthUnits) || 0
  if (maxW <= 0 || w0 <= maxW) return 1
  return Math.max(maxW / w0, minScale(fontSizeMm))
}

// Не влезает даже на минимально допустимом масштабе → в отчёт «не влезло».
export function isOverflow(widthUnits, maxWidthUnits, fontSizeMm) {
  const maxW = Number(maxWidthUnits) || 0
  if (maxW <= 0) return false
  return (Number(widthUnits) || 0) * minScale(fontSizeMm) > maxW
}

// Итоговый масштаб: автоподгонка, домноженная на персональную поправку.
export function totalScale(widthUnits, maxWidthUnits, fontSizeMm, overrideScale = null) {
  const k = fitScale(widthUnits, maxWidthUnits, fontSizeMm)
  const s = Number(overrideScale) || 0
  return s > 0 ? k * s : k
}

// Персональное смещение мм → units контура.
export function offsetUnits(override) {
  if (!override) return [0, 0]
  return [(Number(override.dx_mm) || 0) * 100, (Number(override.dy_mm) || 0) * 100]
}
